import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import user from './user'
import auth from './auth'
import delivery from './delivery'
import region from './region'
import commune from './commune'
import withdrawal from './withdrawal'
import message from './message'
import group from './group'
import regionStore from './regionStore'
import packageStore from './package'
import createPersistedState from 'vuex-persistedstate'
import integration from './integration'
import assignment from './assignment'
import settlement from './settlement'
import shippingService from './shippingService'
import settlementGoogleSheets from './settlementGoogleSheets'
import pickupGoogleSheets from './pickupGoogleSheets'
import cancelledDeliveriesSettings from './cancelledDeliveriesSettings'
import webhookEvent from './webhookEvent'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    store,
    user,
    auth,
    delivery,
    region,
    commune,
    withdrawal,
    message,
    group,
    regionStore,
    packageStore,
    integration,
    assignment,
    settlement,
    shippingService,
    settlementGoogleSheets,
    pickupGoogleSheets,
    cancelledDeliveriesSettings,
    webhookEvent
  },
  plugins: [createPersistedState()]
})
